export default "__VITE_ASSET__a8c6e389__"